<template>
  <div>

    <div class="row mb-3">
      <Period-Selector/>
      <Company-Selector/>
    </div>

    <div class="row">

      <div class="col-xl-3 col-md-6">
        <Payouts-Pending-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-To-Submit-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-Submitted-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-Paid-MiniCard/>
      </div>

    </div>

    <el-tabs v-model="activeTab" @tab-click="updateRendering()">
      <el-tab-pane class="row" label="Payouts" name="Payouts">
        <Payouts-Card class="col-12"/>
      </el-tab-pane>
      <!-- <el-tab-pane class="row" label="Evolution" name="Evolution">
          <Payouts-Graph-Multi-View-Card v-show="$store.getters.companySelected == 0"
                                           class="col-md-8"
                                           title="Evolution of Payouts"
                                          :render="renderMulti"/>
          <Payouts-Pie-Chart-Multi-View-Card v-show="$store.getters.companySelected == 0"
                                               class="col-md-4 pr-3.1"
                                               title="Total Payouts"
                                              :render="renderMulti"/>
          <Payouts-Graph-Single-View-Card v-show="$store.getters.companySelected != 0"
                                            class="col-md-9"
                                            title="Evolution of Payouts"
                                           :render="renderSingle"/>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'Payouts',
  created () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'SET_COMPANY_SELECTED') {
        console.log('subscribe, companySelected = ', state.companySelected)
        this.updateRendering()
      }
    })
  },
  data () {
    return {
      activeTab: 'Payouts',
      renderMulti: false,
      renderSingle: false
    }
  },
  methods: {
    updateRendering () {
      //console.log('updateRendering ()', this.activeTab)
        switch (this.activeTab) {
          case 'Evolution':
            if (this.$store.getters.companySelected == 0) {
              this.renderMulti = true
              this.renderSingle = false
            } else {
              this.renderMulti = false
              this.renderSingle = true
            }
            break
          case 'Payouts':
            this.renderMulti = false
            this.renderSingle = false
            break
          default:
            break
        }
    }, 
  }
}
</script>

<style>
</style>